// LAYOUT
export const HEADER_HEIGHT = 64
export const FOOTER_HEIGHT = 32
export const MENU_ON_SESSION_HEIGHT = 48
export const LAYOUT_CONTENT_PADDING = 24
// 컨덕터 생성 화면(pbo-core)의 폼 행 간격 — 컨덕터 데모 modalShell.css 의 12px 와 같은 값.
// pbo-design screenShell.css 에 같은 규칙이 실리면 그쪽과 맞춘다. 적용 셀렉터는 GlobalStyles.ts(form.ant-form).
export const PBO_FORM_ROW_GAP = 12
// 서치헬퍼 모달 후보 표 — 목록만 스크롤하고 모달 [취소·선택] 버튼은 화면 안에 둔다(rgr01·rgr04 의 360 준용).
// 페이지당 건수는 '몇 개씩' 셀렉트 없이 고정(MOMS 페이저 규칙).
export const HELPER_MODAL_TABLE_MAX_HEIGHT = 360
export const HELPER_MODAL_PAGE_SIZE = 100
// 브랜드명·스타일번호 헬퍼(GET /api/v1/master/products/{brand-names,style-numbers}) 결과 상한 —
// BE MasterItemRepository.OPTION_HELPER_MAX_ROWS 와 같다. 잘림 플래그가 없어 이 건수에 닿으면 잘린 것으로 본다.
export const HELPER_OPTION_MAX_ROWS = 1000
export const HELPER_OPTION_TRUNCATED_MESSAGE = '1,000건까지만 표시합니다. 조건을 좁혀 주세요.'

// URL
export const HOME_PATH = '/'
export const LEGACY_PATH = '/old'

// API
export const API_COMMON_CACHE_TIME = 1000 * 60 * 10 // 10분

/** 여러 화면이 같이 부르는 API 에 부른 화면코드(대문자)를 싣는 헤더 — BE 감사 로그 MENU_CD (moms-be AccessAudit.kt MENU_CODE_HEADER) */
export const MENU_CODE_HEADER = 'X-Menu-Code'
export const API_URL = 'https://api-gw.oms.musinsalogistics.co.kr'
export const DEV_API_URL = {
  DEV: 'https://api-gw-dev.oms.musinsalogistics.co.kr',
  DEV2: 'https://api-gw-dev-2.oms.musinsalogistics.co.kr',
  DEV3: 'https://api-gw-dev-3.oms.musinsalogistics.co.kr',
  LOCAL: 'http://localhost:8080',
} as const

// AUTH — Okta self-lookup 멤버십 상태 errorCode (BE: LOGISPRD-8770/8998 OktaMembershipException → 403).
// gateway 가 매 요청 sentinel(__OKTA_LOOKUP__) 주입 → be AuthInterceptor 가 캐시 없이 fresh 로 상태 재검증하므로
// 로그인 콜백뿐 아니라 세션 중에도 도달 가능(예: 관리자 비활성화). FE 분기 키는 HTTP status 가 아니라 meta.errorCode.
export const AUTH_ERROR_CODE = {
  UNAUTHORIZED: 'ERROR_UNAUTHORIZED', // 게이트웨이 토큰 검증 실패(401)
  USER_NOT_FOUND: 'ERROR_USER_NOT_FOUND', // 미등록 — MOMS_USER_INFO 없음
  USER_NOT_APPROVED: 'ERROR_USER_NOT_APPROVED', // 미승인 — is_valid=false (레거시 E08)
  USER_INACTIVE: 'ERROR_USER_INACTIVE', // 정지/비활성 — is_active=false (레거시 E07). 활성화 요청 전 → deactivated 화면(DEACTIVATED)
  // LOGISPRD-9448: 활성화 요청 후 승인 대기(1.0 header_trust: is_active=false AND activation_requested_at NOT NULL).
  // 로그인 콜백은 deactivated 화면 PENDING 상태로 라우팅한다(HANDOFF §10.1).
  // LOGISPRD-14500: 세션 중 403 은 INACTIVE 와 같이 인터셉터가 안내 후 로그아웃한다(다음 로그인 때 콜백이 PENDING 화면으로 보낸다).
  USER_ACTIVATION_PENDING: 'ERROR_USER_ACTIVATION_PENDING',
  // LOGISPRD-15454: 2.0 메뉴 조회(`/api/v1/auth/me/menus`)의 전환 불가 화주(403). 멤버십 차단이 아니라 로그아웃 대상이 아니다.
  SHIPPER_NOT_CONVERTIBLE: 'ERROR_SHIPPER_NOT_CONVERTIBLE',
} as const

export const HTTP_BAD_REQUEST = 400
export const HTTP_BAD_GATEWAY = 502
export const HTTP_SERVICE_UNAVAILABLE = 503
export const HTTP_GATEWAY_TIMEOUT = 504
// LOGISPRD-15703 — 화주 전환 시 계정 권한에 대상 화주 메뉴가 0개. 1.0 `/api/auth/menu` 는 이때만 400(본문 없음), 2.0 은 200 빈 배열.
export const SHIPPER_NO_MENU_MESSAGE = '이 화주에서 쓸 수 있는 메뉴가 없어 전환할 수 없어요. 계정 권한을 확인해 주세요.'

// 멤버십 403 안내 메시지. NOT_FOUND 는 로그인 콜백에선 회원가입 라우팅(메시지 미사용),
// 세션 중 인터셉터 방어에선 재로그인 안내로 사용한다.
export const AUTH_MEMBERSHIP_ERROR_MESSAGE: Record<string, string> = {
  [AUTH_ERROR_CODE.USER_NOT_FOUND]: '등록되지 않은 계정입니다. 다시 로그인해주세요.',
  [AUTH_ERROR_CODE.USER_NOT_APPROVED]: '승인 대기 중인 계정입니다. 정보보안 담당자 승인 후 이용할 수 있습니다.',
  [AUTH_ERROR_CODE.USER_INACTIVE]: '비활성화된 계정입니다. 활성화가 필요한 경우 관리자에게 요청해주세요.',
  // 로그인 콜백은 deactivated 화면 PENDING 라우팅이라 이 메시지를 쓰지 않는다. 세션 중 인터셉터 안내에서 쓴다(LOGISPRD-14500).
  [AUTH_ERROR_CODE.USER_ACTIVATION_PENDING]: '계정 활성화 승인 대기 중입니다. 관리자 승인 후 이용할 수 있습니다.',
}

// 멤버십 상태 실패(403) 4종 집합. ACTIVATION_PENDING 은 LOGISPRD-14500 에서 추가 — 2.0 authCheck 전환 후
// 2.0 의 모든 /api/** 가 세션 중 이 코드를 낼 수 있다(9448 당시엔 1.0 로그인 콜백에서만 나왔다). 인터셉터의 멤버십 처리와 AuthChecker 의 일반 토큰무효 처리가
// 같은 에러를 이중 처리(중복 alert/logout)하지 않도록, "멤버십 에러" 판정을 양쪽이 공유하는 단일 키.
export const AUTH_MEMBERSHIP_ERROR_CODES: ReadonlySet<string> = new Set([
  AUTH_ERROR_CODE.USER_NOT_FOUND,
  AUTH_ERROR_CODE.USER_NOT_APPROVED,
  AUTH_ERROR_CODE.USER_INACTIVE,
  AUTH_ERROR_CODE.USER_ACTIVATION_PENDING,
])

// errorCode 매핑 실패 시 멤버십 차단 fallback 안내(매직스트링 상수화).
export const AUTH_MEMBERSHIP_FALLBACK_MESSAGE = '계정 상태를 확인할 수 없습니다. 다시 로그인해주세요.'

// REGEX
export const REGEX = {
  password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
  positiveNum: /^\d*[1-9]\d*$/,
  positiveNumWithZero: /^\d*[0-9]\d*$/,
  korean: /^[ㄱ-힣]+$/,
  koreanAndNumber: /^(?=.*[가-힣])[가-힣0-9\s]+$/,
  town: /^[ㄱ-힣][ㄱ-힣\d\s]*[ㄱ-힣\d]$/,
  onlyNumber: /^\d+$/,
  yearMonth: /^\d{4}-(0[1-9]|1[0-2])$/,
}

/** [일괄 입력] 반영 토스트 노출 시간(초) — 저장 안내를 읽을 시간(pbo-design #822, LOGISPRD-15530) */
export const BULK_INPUT_TOAST_SECONDS = 5

// DATE FORMAT
export const DATE_FORMAT = {
  time: 'HH:mm',
  simple: 'MM/DD',
  date: 'YYYY-MM-DD',
  dateSimple: 'YYYYMMDD',
  dateMonthSearch: 'YYYYMM',
  dateMonth: 'YYYY-MM',
  dateNday: 'YYYY-MM-DD (ddd)',
  datetime: 'YYYY-MM-DD HH:mm:ss',
  datetimeNday: 'YYYY-MM-DD (ddd) HH:mm:ss',
}

export const SHIPPERS = {
  MUSINSA: 'MUSINSA',
  MUSINSALOGISTICS: 'MUSINSALOGISTICS',
  MUSINSACN: 'MUSINSACN',
  INTERGRATION_RETURN: 'INTERGRATION_RETURN',
} as const

/** 화주를 자유롭게 고르는 통합 운영 화주. 1.0 `FilterBar` 렌더 규칙과 같다 (LOGISPRD-14650) */
export const FREE_SHIPPERS: string[] = [SHIPPERS.MUSINSA, SHIPPERS.MUSINSALOGISTICS, SHIPPERS.MUSINSACN, SHIPPERS.INTERGRATION_RETURN]

// time
export const SECOND = 1000
export const MINUTE = 60 * SECOND
export const HOUR = 60 * MINUTE

// 엑셀 다운로드 사유 모달 — 사유코드 옵션(GET /api/v1/combos, DOWNLOAD_CD)이 비었을 때의 안내.
// 옵션이 없으면 라디오가 하나도 안 그려지고 사유코드가 '' 로 남아 확인이 영영 비활성이라 이유를 화면에 남긴다.
// 콤보 조회 실패, MOMS_COMBO_INFO.DOWNLOAD_CD 미등록, 요청 코드 목록 누락 세 경로로 도달한다(LOGISPRD-12615).
// GR01·EGR01·GI24 가 참조한다. GR02 2.0(gr02V2)·입고조회 전체(allInboundStatus)는 문구가 달라
// ('사유코드를 … 시도해 주세요.') 아직 여기로 모으지 않았다 — 문구 통일은 별도 건이다.
export const DOWNLOAD_REASON_EMPTY_MESSAGE = '사유 목록을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.'
